/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Model_HintInputs */



/**
* | output |
* | --- |
* | "Choose the model (Eleven v4, Multilingual v2 or Flash v2.5) for each event in the Event List." |
*
* @param {Voice_Manager_Elevenlabs_Model_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_model_hint = /** @type {((inputs?: Voice_Manager_Elevenlabs_Model_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Model_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez le modèle (Eleven v4, Multilingual v2 ou Flash v2.5) de chaque événement dans la liste des événements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das Modell (Eleven v4, Multilingual v2 oder Flash v2.5) für jedes Ereignis in der Ereignisliste.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli il modello (Eleven v4, Multilingual v2 o Flash v2.5) per ogni evento nell'elenco eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите модель (Eleven v4, Multilingual v2 или Flash v2.5) для каждого события в списке событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige el modelo (Eleven v4, Multilingual v2 o Flash v2.5) de cada evento en la lista de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在事件列表中为每个事件选择模型（Eleven v4、Multilingual v2 或 Flash v2.5）。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントリストで、イベントごとにモデル（Eleven v4、Multilingual v2、Flash v2.5）を選択します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट सूची में हर इवेंट के लिए मॉडल (Eleven v4, Multilingual v2 या Flash v2.5) चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha o modelo (Eleven v4, Multilingual v2 ou Flash v2.5) de cada evento na lista de eventos.")
	return /** @type {LocalizedString} */ ("Choose the model (Eleven v4, Multilingual v2 or Flash v2.5) for each event in the Event List.")
});